/**
 * 表单字段配置项
 */

export default {
  // 文本域字段
  textareaFields: ['introduction', 'enIntroduction', 'productIntro', 'productEnIntro', 'productEIntro', 'mainBusinessScope', 'enMainBusinessScope', 'sourcingDemand', 'enSourcingDemand', 'abroadWarehouse', 'enAbroadWarehouse'],
  // 国家phoneCode字段
  phoneCodeFields: ['telephone', 'fax', 'mobile', 'linkMobile1', 'linkMobile'],
  // 城市phoneCode字段
  cityPhoneCodeFields: ['telephone', 'fax'],
  // 总部国家phoneCode字段
  phoneCodeFieldsQH:['telephoneHeadQuater','faxHeadQuater'],
  // 总部城市城市phoneCode字段
  cityPhoneCodeFieldsQH:['telephoneHeadQuater','faxHeadQuater'],
  // 带http://地址字段
  httpFields: ['webUrl', 'url3d', 'website', 'websiteHeadQuater'],
  // 允许输入空格的字段
  allowSpaceFields: ['name', 'corporateName', 'brand', 'address', 'addressHeadQuater', 'post']
}